import styles from "./Button.module.css";
import {Button} from "@base-ui/react/button";

export default function GradientButton({style={}, onClick, children, label=""}) {
    return (
        <Button aria-label={label} className={styles.gradientWrap} style={style} onClick={onClick}>
            <span className={styles.gradientBtn}>
                {children}
            </span>
        </Button>

    );
}